import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./lib/cart";
import { SearchProvider } from "./lib/search";
import LenisProvider from "./components/Lenis";
import ScrollToTop from "./components/ScrollToTop";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import Track from "./pages/Track";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import Contact from "./pages/Contact";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#060709] text-ink p-8">
          <div className="border border-white/10 p-8 max-w-md">
            <p className="font-mono text-[11px] tracking-widest text-volt">SYSTEM FAULT</p>
            <p className="mt-3 text-sm text-dim">{String(this.state.error?.message || this.state.error)}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
function Site() {
  return (
    <div className="grain min-h-screen bg-[#060709] text-ink">
      <ScrollToTop />
      <Nav />
      <CartDrawer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
        <Route path="/track" element={<Track />} />
        <Route path="/privacy" element={<Legal />} />
        <Route path="/terms" element={<Legal />} />
        <Route path="/refund" element={<Legal />} />
        <Route path="/shipping" element={<Legal />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LenisProvider>
          <CartProvider>
            <SearchProvider>
              <Routes>
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Site />} />
              </Routes>
            </SearchProvider>
          </CartProvider>
        </LenisProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#151821", border: "1px solid rgba(255,255,255,0.1)", color: "#F4F4F6", fontFamily: "JetBrains Mono", fontSize: 12 } }} />
    </ErrorBoundary>
  );
}
